<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <h5 class="modal-title"></h5>
          <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" @click="closeModalMethod">
            <i class="fas fa-lg fa-times"></i>
          </button>
        </div>
        <div class="modal-body text-center">
          <img src="@/assets/images/rebrandLogo2.png" class="logo" />
          <div class="steps-bar-container">
            <ul class="progressbar">
              <li :class="{'done':isProgressing[key], 'active': selected === key}" v-for="(step,key) in steps" :key="key">
                <i class="fas fa-check-circle" :class="{'no-line': key == steps.length - 1}"></i>
                <span>{{key + 1}}.&nbsp;{{step}}</span>
              </li>
            </ul>
          </div>
          <h1 class="heading-medium mb-5" v-if="selected === 0">First tell us what service you are interested in.</h1>
          <h1 class="heading-medium mb-5"  v-else-if="selected === 1">And what fuels do you want to see ?</h1>
          <h1 class="heading-medium mb-5"  v-else-if="selected === 2">Where do you want to source fuel from ?</h1>
          <h1 class="heading-medium mb-5"  v-if="showSuccessMessage">We are creating your personalized market</h1>
          <div v-if="loading">
            <pulse-loader :loading="loading"></pulse-loader>
          </div>
          <div class="success-icon-container">
            <i v-if="!loading && showSuccessMessage" class="fa fa-check-circle fa-5x"></i>
          </div>

          <div class="menu-container justify-content-center d-flex flex-wrap" :class="classObject">
            <div class="m-2" v-for="(item,key) in menuData[`${selected}`]" :key="key">
              <span
                v-if="!isCheckmark && selected!==2"
                :class="[ (isServiceSelected[key] && selected===0) ? 'btn btn-tertiary mx-1' : 'btn btn-outline-tertiary mx-1']"
                @click="selectServicesAndFuels(item,key)"
              >
                {{item}}
              </span>
              <input
                v-if="isCheckmark && selected!==2"
                type="checkbox"
                :value="item"
                :id="'checkMark-' + key"
                v-model="favSelected.fuels"
              >
              <label 
                v-if="isCheckmark && selected!==2"
                :for="'checkMark-' + key">
                {{ item._id | fueltype}}
              </label>
            </div>
          </div>
           <!-- IMPLEMENTING INCREMENTAL SEARCH FOR TERMINALS -->
          <div v-if="selected===2" class="terminals-container">
            <div class="row">
              <div class="col-md-12">
                <form v-on:submit.prevent="onSubmit" autocomplete="off" class="search-form">
                  <div class="icon-container">
                    <i class="fas" :class="showMatchesList ? 'fa-chevron-up' : 'fa-chevron-down'" @click="showAll"></i>
                  </div>
                  <input class="search-bar-input" v-model="terminalsIncremental.name"
                    @keyup.down="onArrowDown" 
                    @keyup.up="onArrowUp" 
                    @input="incrementalSearchMatches" 
                    @click="hideCompleteList"
                    type="text" placeholder="Search Terminals here...">
                  <div class="matches-list position-relative" :class="{visible:showMatchesList}" >
                    <ul>
                      <li v-if="matchesFound.length < 1" class="matches-list-elements no-match">
                        No matching terminal found
                      </li>
                      <li v-else v-for="(terminal,key) in matchesFound" class="matches-list-elements" 
                        :class="{selected:mathcesListIndex===key}"  @click="selectTerminal(terminal, terminal._id)" :key="key">
                        {{terminal._id |terminalsname}}
                      </li>
                    </ul>
                  </div>  
                </form>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 show-selected mt-3">
                <h5>Terminals selected ({{favSelected.terminalsSelected.length}})</h5>
                <div class="w-50 mx-auto d-flex mt-2 justify-content-center flex-wrap">
                  <div class="btn btn-tertiary m-1" v-for="(terminal,key) in favSelected.terminalsSelected" :key="key" @click="selectTerminal(terminal, terminal._id)">  
                    {{terminal._id |terminalsname}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!showSuccessMessage" class="modal-footer d-flex justify-content-center mt-5 mb-5">
          <button class="btn btn-tertiary mr-2" @click="prevStep" :disabled="selected === 0">Back</button>
          <button class="btn btn-primary" @click="nextStep"
            :disabled="((selected === 0 && favSelected.services.length < 1) ||
              (selected === 1 && favSelected.fuels.length < 1) || 
              (selected === 2 && favSelected.terminalsSelected.length < 1))">
            <span>{{ selected !==2 ? buttonLabel[0] : buttonLabel[1] }}</span>
          </button>
        </div>
        <div v-if="showSuccessMessage && !loading" class="modal-footer d-flex justify-content-center mt-5 mb-5">
          <button class="btn btn-secondary" id="go-to-market" @click="goToMarket">Go to Markets</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    PulseLoader
  },
  data: function() {
    return {
      isProgressing: [],
      steps: ["Services", "Product", "Terminals", "Done!"],
      selected: 0,
      servicesList: ["Ex-Rack", "Bunkering", "Delivered in", "Contracts"],
      menuData: {
        0: [],
        1: []
        //terminals will be added
      },
      terminalsList:[],
      styles: ["services", "fuels", "terminals"],
      styleSelected: "services",
      terminalsIncremental: {_id:'',name:''},
      favSelected: {
        services: [],
        fuels: [],
        terminalsSelected:[],
        networks: []
      },
      isCheckmark: false,
      isServiceSelected: [false, false, false],
      isPlusSelected: [],
      findIndex: "",
      buttonLabel: ["Next", "Finish"],
      isTerminalSelected: [],
      showSuccessMessage: false,
      loading: false,
      showMatchesList:false,
      matchesFound:[],
      mathcesListIndex:-1
    };
  },
  computed: {
    ...mapState('login', ['userLoggedIn']),
    ...mapState("selectFavourites", ["marketFavouritesList","listOfServicesCreated"]),
    ...mapGetters('metadata', ['networks']),
    classObject() {
      if (this.styleSelected === "fuels") {
        this.isCheckmark = true;
      } else {
        this.isCheckmark = false;
      }
      return this.styleSelected;
    }
  },
  methods: {
    ...mapActions("selectFavourites", ["closeModal", "favouritesCreated","insertFavourite","selectFavouriteOption", 'updateFavouritesMarkets']),
    nextStep() {
      const loadingSuccess = () => {
        this.showSuccessMessage = true;
        this.loading = true;
        setTimeout(() => (this.loading = false), 2500);
      };
      //check for bunkering and Contracts
      if (this.favSelected.services.find(service => service === "Bunkering" || service === "Contracts")) {
        /* If Contracts is selected, then push all 'SPOT' fuels */
        if (this.favSelected.services.find(service => service === "Contracts")){
          this.menuData[1].forEach(fuel => {
            if (!this.favSelected.fuels.includes(fuel)){
              this.favSelected.fuels.push(fuel)
            }
          })
        }
        
        // Adding bunkering networks
        this.favSelected.networks = this.networks;
        
        this.steps.splice(1, 2);
        this.selected = 3;
        this.isProgressing.splice(1, 1, true);
        this.writeToDB().then(response => {
          if (response) {
            loadingSuccess();
          }
        });
      }
      // check for Deliverd In
      if (this.favSelected.services.find(service => service === "Delivered in") && this.favSelected.fuels.length > 0) {
          this.steps.splice(2, 1, "Done!");
          this.steps.pop();
          this.selected = 3;
          this.isProgressing.splice(1, 2, true, true);
          this.writeToDB().then(response => {
            if (response) {
              loadingSuccess();
            }
          });
      }

      let changeTheLastStepInBar = false;
      if (this.selected === 2) {
        changeTheLastStepInBar = true;
        this.writeToDB().then(response => {
          if (response) {
            loadingSuccess();
          }
        });
      }

      this.selected += 1;
      this.styleSelected = this.styles[this.selected];
      let index = this.selected - 1;
      this.isProgressing.splice(index, 1, true, changeTheLastStepInBar);
    },

    prevStep() {
      let changeTheLastStepInBar = true;
      if (this.selected === 0) {
        return;
      }
      if (this.selected === 3) {
        changeTheLastStepInBar = false;
        this.isProgressing.splice(this.selected, 1, false);
      }
      this.selected -= 1;
      this.styleSelected = this.styles[this.selected];
      this.isProgressing.splice(this.selected, 1, false);
      const style = this.styles[this.selected];
      let currentElement = this.favSelected[`${style}`];
    },

    writeToDB: async function() {
      const favourites = this.favSelected;
      const key = 'FAVOURITE_MARKETS'

      const payload = {
        favouriteMarkets: this.marketFavouritesList,
        newFavourite: favourites,
        userId: this.userLoggedIn.userId,
        key: 'FAVOURITE_MARKETS'
      }

      const response = await this.axios.post("/api/insertFavourites", payload);
      
      /* If saving was successful, fetch the updated favourites list, then select the newly created */
      if (response.data.success) {
        const fetchResponse = await this.axios.get('/api/getFavourites', {params: {
            userId: this.userLoggedIn.userId, 
            key: key
          }})
        
        if (fetchResponse.data.success){
          this.updateFavouritesMarkets(fetchResponse.data.payload.favouriteMarkets)
          //send data to the store
          // this.insertFavourite({favourites})
          
          const key = this.marketFavouritesList.length - 1
          const serviceName = favourites.services[0]
          this.selectFavouriteOption({key, serviceName})
        }

        return response;
      } else {
        //error
        console.log("error saving favourites ****");
      }
    },

    selectServicesAndFuels(item, key) {
      const keyObj = this.styleSelected;
      const isItemAlreadySelected = this.favSelected[keyObj].includes(item);

      let toggle;
      //if it's fuel
      this.styleSelected === "fuels"
        ? (this.isPlusSelected[key] === true
            ? (toggle = false)
            : (toggle = true),
          this.isPlusSelected.splice(key, 1, toggle))
        : "";

      //when clicking a selected item
      if (isItemAlreadySelected && keyObj === "services") {
        const index = this.favSelected[keyObj].indexOf(item);
        this.favSelected[keyObj].splice(index, 1);
        this.isServiceSelected.splice(key, 1, false);
        return;
      }
    
      if (keyObj === "services") {
          const service = this.favSelected[keyObj].find(
            service => service !== ""
          );
          let indexItemToRemove;
          if (service) {
            indexItemToRemove = this.favSelected[keyObj].findIndex(
              element => element === service
            );
        }

        const index = this.isServiceSelected.findIndex(
          service => service === true
        );
        if (index > -1) {
          this.isServiceSelected.splice(index, 1, false);
          const indexOnFavourite = this.favSelected[keyObj].indexOf(item);
          this.favSelected[keyObj].splice(indexItemToRemove, 1);

        }
        this.isServiceSelected.splice(key, 1, true);
      }

      this.favSelected[keyObj].push(item);
    },
    goToMarket() {
      this.favouritesCreated();
      this.closeModal();
      $(this.$el).modal("hide");
    },
    closeModalMethod(){
      this.closeModal();
    },
    
    // TERMINAL INCREMENTAL SEARCH
    selectTerminal(terminal, terminalId){
      /* Check whether this terminal has been added to favourites or not, if not add it to the list */
      const checkIfPresent = this.favSelected.terminalsSelected.find(terminal => terminal._id === terminalId)
      if(!checkIfPresent){
        this.favSelected.terminalsSelected.push(terminal)
        return 
      }

      /* Otherwise remove it from the list */
      const index = this.favSelected.terminalsSelected.findIndex(el => el._id === terminalId)
      this.favSelected.terminalsSelected.splice(index,1)   
    },
    showAll(){
        this.showMatchesList=!this.showMatchesList;
        this.matchesFound=this.terminalsList;
    },
    onArrowDown(){
        const elements = document.getElementsByClassName('matches-list-elements')
            if(this.mathcesListIndex < elements.length-1){       
                this.mathcesListIndex++;
              
            }
    },
    onArrowUp(){
          if(this.mathcesListIndex>0){
                this.mathcesListIndex--
            }
    },
    incrementalSearchMatches(){
      const inputToMatch = this.terminalsIncremental.name.toLowerCase()
      this.matchesFound = []
      if(inputToMatch){
        this.showMatchesList=true;
        this.terminalsList.forEach(terminal=>{
          if(terminal.name.toLowerCase().indexOf(inputToMatch)>-1){
            this.matchesFound.push(terminal)
          }
        })
      }
      else {
        this.matchesFound=this.terminalsList;
      }
    },
    hideCompleteList(){

    }
  },
  created: async function() {
    /* Show only services which have not been added to favourite markets */
    this.servicesList.forEach((service, index) => {
      if (!this.listOfServicesCreated.includes(service)){
        this.menuData[0].push(service)
      }
    })

    const terminalList = await this.axios.get("/api/getTerminalList");
    if(terminalList.data.success){
        this.terminalsList = terminalList.data.terminalList
    }
    // get fuels list 
    const fuelsList = await this.axios("/api/getFuelsList")
    if(fuelsList.data.success){
        fuelsList.data.payload.forEach(fuel=>{
          if(fuel.type==="SPOT"){
            this.menuData[1].push(fuel)
          }
        })
    }
    this.menuData[1].forEach(fuel => this.isPlusSelected.push(true));
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/scss/components/_progress.scss";
@import "@/assets/scss/components/_modals.scss";
</style>